export default function (cell, formatterParams = {}) {
  let value = cell.getValue();

  const { numberFormatterOptions = {}, suffix = '' } = formatterParams;

  if (value === false || value === null || value === undefined) {
    return '';
  }

  if (value === '-') {
    return value;
  }

  if (typeof value !== 'number') {
    value = parseFloat(value);
  }


  if (numberFormatterOptions.style === 'percent') {
    value = value / 100;
  }

  let string = value.toLocaleString(undefined, numberFormatterOptions);

  if (suffix) {
    string = `${string}${suffix}`;
  }

  return string
}
